export default {
  // Application
  createApplication: 'application.can_create',
  viewOtherApplications: 'application.can_view_other',
  editOtherApplications: 'application.can_edit_other',
  duplicateOtherApplications: 'application.can_duplicate_other',
  canSkipForeignSign: 'application.can_skip_foreign_sign',
  canSkipTerminalSign: 'application.can_skip_terminal_sign',
  canSeeUsersInLogs: 'application.can_see_users_in_logs',
  canEditVisitorAvatar: 'application.can_edit_visitor_avatar',
  canViewVisitorAvatar: 'application.can_view_visitor_avatar',
  canUseInternalComment: 'application.can_use_internal_comment',
  // Application list
  sortApplicationBySubdivision: 'application.can_sort_by_subdivision',
  printApplicationPrintedForm: 'application.can_print_application_printed_form',
  // Admin Panel
  pdfPassBackgroundAdminPanelPage: 'admin_panel.can_use_pdf_pass_background_page',
  pdfPassViewAdminPanelPage: 'admin_panel.can_use_pdf_pass_view_page',
  blacklistAdminPanelPage: 'admin_panel.can_use_blacklist_page',
  userAdminPanelPage: 'admin_panel.can_use_user_page',
  // Blacklist
  viewBlacklist: 'blacklist.can_view',
  viewGeneralBlacklist: 'blacklist.can_view_general',
  // IssuedPassesPage
  canUseIssuedPassesPage: 'issued_passes.can_use_page',
  canUsePdfExportOnIssuedPassesPage: 'issued_passes.can_use_pdf_export',
  // PhdList
  canUsePhdListPage: 'phd_list.can_use_page',
  // PassVerify
  canViewPassVerifyPage: 'pass_verify.can_view',
  canUsePassVerifyPage: 'pass_verify.can_use',
  // PassActions
  canUsePassActions: 'pass_actions.can_use'
}
